import { httpPost } from 'shared/services/httpService';
import appSettings from 'shared/settings/appSettings';
import {
    UserApprovalItem,
    UserApprovalQueryModel,
    UserApprovalResult
} from 'shared/models/api/models';

const userApprovalsUriPath = new URL('/api/user/user-approvals', appSettings.api.portalApi);
const userApprovalsListUri = `${userApprovalsUriPath}/list`;
const userApprovalsApproveUri = `${userApprovalsUriPath}/approve`;
const userApprovalsRejectUri = `${userApprovalsUriPath}/reject`;
const userApprovalsReactivateUri = `${userApprovalsUriPath}/reactivate`;

export const getUserApprovals = async (query: UserApprovalQueryModel): Promise<UserApprovalItem[]> => {
    const items = await httpPost<UserApprovalItem[]>(userApprovalsListUri.toString(), query)
        .catch((e) => {
            console.log(e);
            return [] as UserApprovalItem[];
        });
    return items ?? [];
};

export const approveUserApproval = async (id: string): Promise<UserApprovalResult | null> => {
    return await httpPost<UserApprovalResult>(`${userApprovalsApproveUri}/${id}`)
        .catch((e) => {
            console.log(e);
            return null;
        });
};

export const rejectUserApproval = async (id: string): Promise<UserApprovalResult | null> => {
    return await httpPost<UserApprovalResult>(`${userApprovalsRejectUri}/${id}`)
        .catch((e) => {
            console.log(e);
            return null;
        });
};

export const reactivateUserApproval = async (id: string): Promise<UserApprovalResult | null> => {
    return await httpPost<UserApprovalResult>(`${userApprovalsReactivateUri}/${id}`)
        .catch((e) => {
            console.log(e);
            return null;
        });
};
